import styled from "styled-components";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { colors } from "utils";

export const LEVEL_COLORS = {
  1: { bg: colors.pink50, border: colors.pink300, text: colors.pink900 },
  2: { bg: colors.amber50, border: colors.orange300, text: colors.amber800 },
  3: { bg: colors.green50, border: colors.green300, text: colors.green700 },
  4: { bg: colors.blue50, border: colors.blue300, text: colors.blue800 },
};

const Tag = styled.span`
  display: inline-flex;
  align-items: center;
  gap: 4px;
  border-radius: 11px;
  padding: 2px 8px;
  font-size: 14px;
  font-weight: 400;
  white-space: nowrap;
  line-height: 1.4;
  max-height: 24px;
  background-color: ${({ $bg }) => $bg};
  border: 1px solid ${({ $border }) => $border};
  color: ${({ $text }) => $text};
`;

export const TagLevelSmall = ({ level, icon, compact = false }) => {
  const colorSet = LEVEL_COLORS[level];
  if (!colorSet) return null;

  return (
    <Tag $bg={colorSet.bg} $border={colorSet.border} $text={colorSet.text}>
      {icon && <FontAwesomeIcon icon={icon} style={{ fontSize: 12 }} />}
      {compact ? `L${level}` : `Level ${level}`}
    </Tag>
  );
};
